module.exports = __webpack_public_path__ + "img/icon_map_7.cc589d5e.png";